module.exports = __webpack_public_path__ + "img/icon_pod_outlined_w.250a7e3a.svg";